import React from 'react'
import moment from 'moment'
import Placeholder from '../misc/placeholder'
//import SectionTableVertical from './SectionTableVertical'
import { connect } from 'react-redux'

const Files = (props) => {
    const folder = props.data
    const { is_user_confidential, is_user_editor } = props
    //console.log(folder.confidential, 'cfd user', is_user_confidential, 'adm user', is_user_editor)
    if (folder.confidential && folder.confidential === true && !is_user_confidential && !is_user_editor) {
        return null
    }

    //console.log(folder.label, folder.files)

    return (
        <React.Fragment>
            <section className="section print-none">
                <h3 className="section-header">{folder.confidential ? <i className="fas fas-spc fa-lock fa-xs" /> : null}{folder.label || 'File List'}</h3>
                <div className="table-responsive">
                    {!folder.files && (
                        <Placeholder />
                    )}
                    {folder.files && folder.files.length ? (
                        <table className="table table-hover table-striped">
                            <thead>
                                <tr>
                                    <th>Filename</th>
                                    <th className="d-none d-sm-block">Date Created</th>
                                    <th>Date Modified</th>
                                    <th className="d-none d-sm-block print-none">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {folder.files.map(file => (
                                    <tr key={file.UniqueId}>
                                        <td><a className="default-color strong" href={file.URL} target="_blank" rel="noopener noreferrer">{file.Name}</a></td>
                                        <td className="d-none d-sm-block">{moment(file.TimeCreated).format('lll')}</td>
                                        <td className="nowrap">{moment(file.TimeLastModified || file.TimeCreated).format('lll')}</td>
                                        <td className="text-right d-none d-sm-block print-none">
                                            <a target="_blank" rel="noopener noreferrer" href={file.URL} className="btn btn-sm btn-secondary"><i className="fas fa-eye"></i> View</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                            <React.Fragment>
                                <p>No files for this category.</p>
                                <hr />
                            </React.Fragment>
                        )}
                </div>
            </section>
        </React.Fragment>
    )
}

const mapStateToProps = ({ okta }) => {
    return {
        is_user_confidential: okta.is_user_confidential,
        is_user_editor: okta.is_user_editor
    }
}

export default connect(mapStateToProps)(Files)